import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollHeight = window.pageYOffset;
        setIsVisible(scrollHeight > 300);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        // הוספת passive: true משפרת את ביצועי הגלילה בדפדפן
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <button
            onClick={scrollToTop}
            aria-label="חזור לראש העמוד"
            className={`
                fixed bottom-6 right-6 z-50
                flex h-12 w-12 items-center justify-center rounded-full 
                bg-surface border border-secondary-dark text-primary
                shadow-soft transition-all duration-300 ease-out
                hover:bg-primary hover:text-white hover:border-primary hover:shadow-hover hover:-translate-y-1
                focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
                ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'}
            `}
        >
            <ArrowUp className="h-8 w-8" strokeWidth={2.5} />
        </button>
    );
};

export default ScrollToTop;